/** @jsx jsx */
import * as React from "react";
import { IResourceSchedule } from "../../models/Roster/RosterResponse";
import * as moment from "moment";
import { AppConstants } from "../../utils/AppConstants";
import { ITimeInterval } from "../../models/Roster/ITimeInterval";
import AppUtils from "../../utils/AppUtils";
import { rosterStyles } from "../../styles/roster/mobile/roster";
import { jsx, css } from "@emotion/core"
import { RosterCalendarStyles } from "../../styles/components/Roster/RosterCalendar";


interface IRosterCardProps {
    slotsForTheDay: IResourceSchedule[];
    date: string;
    openAddHoursModal(date: string): void;
    openCopyModal(shifts: ITimeInterval): void;
    openEditModal(date: string): void;
    onCardExpand(): void
    style?: React.CSSProperties;
    shouldDisable?: boolean;
}

interface IRosterCardState {
    shouldShowAll: boolean;
}

export class RosterCard extends React.Component<IRosterCardProps, IRosterCardState>{
    constructor(props: IRosterCardProps) {
        super(props);
        this.state = {
            shouldShowAll: false
        };
        this.copyShift = this.copyShift.bind(this);
        this.toggleView = this.toggleView.bind(this);
    }

    private copyShift(shift: IResourceSchedule): void {
        this.props.openCopyModal({ startTime: shift.startTime, endTime: shift.endTime });
    }

    private toggleView() {
        const { shouldShowAll } = this.state;
        this.setState({ shouldShowAll: !shouldShowAll });
        this.props.onCardExpand();
    }
    render() {
        const { date, slotsForTheDay, openEditModal, style, shouldDisable } = this.props;
        const { shouldShowAll } = this.state;
        const isMobile: boolean = AppUtils.getIsMobile();
        return (<div css={isMobile ? rosterStyles.rosterCardContainer : RosterCalendarStyles.rosterCard} className={shouldDisable ? "roster-card-container disable" : "roster-card-container"} style={style}>
            {!isMobile && <div className={slotsForTheDay.length > 0 ? "roster-card-header bottom-line" : "roster-card-header"}>
                < React.Fragment >
                    <div className="roster-header-text">{moment(date, AppConstants.dateFormat).format("DD")}</div>
                    <div className="roster-edit" onClick={() => openEditModal(date)} >
                        {slotsForTheDay.length > 0 &&
                            <React.Fragment>
                                <img src="/images/edit-pencil.svg" />
                                <span className="edit-label">EDIT</span>
                            </React.Fragment>
                        }
                    </div>
                    <hr className="divider"></hr>
                </React.Fragment >
            </div >}

            {
                isMobile &&
                <div css={rosterStyles.rosterCardLeft}>
                    <div css={rosterStyles.rosterTextMedium}>{moment(date, AppConstants.dateFormat).format("DD")}</div>
                    <div css={rosterStyles.rosterTextBold}>{moment(date, AppConstants.dateFormat).format("ddd")}</div>
                    {slotsForTheDay.length > 0 &&
                        <div css={rosterStyles.editBtn} onClick={() => openEditModal(date)}>
                            <img src="/images/edit.png" onClick={() => openEditModal(date)} css={rosterStyles.editImg} />
                            <span>EDIT</span>
                        </div>
                    }
                </div>
            }
            <div css={isMobile ? rosterStyles.rosterCardMiddle : {}} className="roster-card-body">
                {slotsForTheDay.length > 0 &&
                    slotsForTheDay.map((currentSlot, index: number) => {
                        const startTime = AppUtils.getEpochFromDateAndTime(currentSlot.workingDayDate, currentSlot.startTime);
                        const endTime = AppUtils.getEpochFromDateAndTime(currentSlot.workingDayDate, currentSlot.endTime);
                        if (shouldShowAll) {
                            return (<div css={isMobile ? rosterStyles.workingHoursView : {}}>
                                <div key={currentSlot.id} className="roster-time-slot">{`${moment(startTime).format("hh:mm A")} to ${moment(endTime).format("hh:mm A")}`}</div>
                                <div css={isMobile ? rosterStyles.copyBtn : {}} className="copy-btn"
                                    onClick={() => this.props.openCopyModal({ startTime: currentSlot.startTime, endTime: currentSlot.endTime })}>
                                    <img src="/images/copy.svg" alt="copy" css={isMobile ? rosterStyles.copyIcon : {}} />
                                    <span>COPY</span>
                                </div>
                                {!isMobile &&
                                    <hr></hr>
                                }
                            </div>)
                        } else if (!shouldShowAll && index < 2) {
                            return (<div css={isMobile ? rosterStyles.workingHoursView : {}}>
                                <div key={currentSlot.id} className="roster-time-slot">{`${moment(startTime).format("hh:mm A")} to ${moment(endTime).format("hh:mm A")}`}</div>
                                <div css={isMobile ? rosterStyles.copyBtn : {}} className="copy-btn"
                                    onClick={() => this.props.openCopyModal({ startTime: currentSlot.startTime, endTime: currentSlot.endTime })}>
                                    <img src="/images/copy.svg" alt="copy" css={isMobile ? rosterStyles.copyIcon : ""} />
                                    <span>COPY</span>
                                </div>
                                {!isMobile &&
                                    <hr></hr>
                                }
                            </div>)
                        } else {
                            return (<React.Fragment></React.Fragment>)
                        }

                    })

                }
                {slotsForTheDay.length === 0 && !isMobile &&
                    <div className="add-hours" onClick={() => this.props.openAddHoursModal(date)}>
                        <div className="plus-icon-container">
                            <div>+</div>
                        </div>
                        <div className="add-text">Add Working Hours</div>
                    </div>
                }
                {slotsForTheDay.length === 0 && isMobile &&
                    <div onClick={() => this.props.openAddHoursModal(date)}>
                        <span className="glyphicon glyphicon-plus-sign"></span> Add Working Hours
                    </div>
                }
            </div>
            <div className="roster-card-footer">
                {slotsForTheDay.length > 2 &&
                    <React.Fragment>
                        <div>{slotsForTheDay.length - 2} more</div>
                        <img src="/images/date-right-nav.png" onClick={this.toggleView} className={shouldShowAll ? "close-btn" : "open-btn"}></img>

                    </React.Fragment>
                }
            </div>

        </div >)
    }

}